import { LIMIT_CHAR, METADATA_FIELDS_TYPE } from "@constants";
import * as yup from "yup";
import i18n from "i18next";

export function getPropertyPanelPromptPresetsMetadata({ data, onHandleSubmitUpdatePreset, isEditButtonDisabled }) {
    return [
        {
            title: undefined,
            attributions: [
                {
                    id: "description",
                    type: METADATA_FIELDS_TYPE.TEXT_AREA,
                    subtitle: "Description",
                    value: data.description,
                    isEditable: !isEditButtonDisabled,
                    onSubmitEditValue: (value) => onHandleSubmitUpdatePreset("description", value),
                    validationRule: yup.object().shape({
                        fieldValue: yup
                            .string()
                            .max(
                                LIMIT_CHAR.description,
                                i18n.t(
                                    `common::msg::This field can be up to {{maxLength}} characters.`,
                                    `This field can be up to {{maxLength}} characters.`,
                                    { maxLength: LIMIT_CHAR.description },
                                ),
                            ),
                    }),
                },
                {
                    id: "prompt",
                    type: METADATA_FIELDS_TYPE.TEXT_AREA,
                    subtitle: "Prompt",
                    value: data.prompt,
                    isEditable: !isEditButtonDisabled,
                    isRequired: true,
                    validationRule: yup.object().shape({
                        fieldValue: yup
                            .string()
                            .required(i18n.t("Prompt is required.", "Prompt is required."))
                            .max(
                                LIMIT_CHAR.description,
                                i18n.t(
                                    `common::msg::This field can be up to {{maxLength}} characters.`,
                                    `This field can be up to {{maxLength}} characters.`,
                                    { maxLength: LIMIT_CHAR.description },
                                ),
                            ),
                    }),
                    onSubmitEditValue: (value) => onHandleSubmitUpdatePreset("prompt", value),
                },
            ],
        },
    ];
}
